enum DatePrecision {
    Year = "Year",
    Month = "Month",
    Day = "Day"
}

export default DatePrecision;